import { PayloadAction } from '@reduxjs/toolkit';
import { ICreateProjectErrors, ProjectStateReducerCreator } from '../types';

const setCreateProjectErrorFieldsReducer = (create: ProjectStateReducerCreator) => {
  return create.reducer((state, action: PayloadAction<ICreateProjectErrors | null>) => {
    state.createProjectErrors = action.payload;
  });
};

export default setCreateProjectErrorFieldsReducer;
